import Exclamation from '../../src/legacy/Exclamation.tsx';
export default Exclamation;
